import {I18nKeys} from '@multipass-i18n';
import {buttonClassName, Card, Container, Feature, IconChip} from '@multipass-ui-components';
import {ArrowRight, CloudOff} from 'lucide-react';
import * as React from 'react';

import {I18nKey, useT} from '../../logic';
import {RouterLink} from '../shell/RouterLink';

const steps: {titleKey: I18nKey; bodyKey: I18nKey; lineKey: I18nKey}[] = [
    {titleKey: I18nKeys.landing.step1Title, bodyKey: I18nKeys.landing.step1Body, lineKey: I18nKeys.landing.step1Line},
    {titleKey: I18nKeys.landing.step2Title, bodyKey: I18nKeys.landing.step2Body, lineKey: I18nKeys.landing.step2Line},
    {titleKey: I18nKeys.landing.step3Title, bodyKey: I18nKeys.landing.step3Body, lineKey: I18nKeys.landing.step3Line},
    {titleKey: I18nKeys.landing.step4Title, bodyKey: I18nKeys.landing.step4Body, lineKey: I18nKeys.landing.step4Line},
];

export const HowItWorksSection: React.FunctionComponent = () => {
    const t = useT();
    return (
        <section id="how" className="py-16">
            <Container>
                <div className="mx-auto mb-10 max-w-[60ch] text-center">
                    <h2 className="mb-3 text-headline">{t(I18nKeys.landing.howTitle)}</h2>
                    <p className="text-text-secondary">{t(I18nKeys.landing.howBody)}</p>
                </div>
                <div className="grid grid-cols-[repeat(auto-fit,minmax(250px,1fr))] gap-5">
                    {steps.map(({titleKey, bodyKey, lineKey}, index) => (
                        <Feature
                            key={titleKey}
                            title={t(titleKey)}
                            lead={<span className="mb-4 grid h-[38px] w-[38px] place-items-center rounded-full bg-brand/15 font-display text-label font-bold text-brand-emphasis">{index + 1}</span>}
                            caption={<span className="mt-4 block text-caption text-text-muted">{t(lineKey)}</span>}
                        >
                            {t(bodyKey)}
                        </Feature>
                    ))}
                </div>
                <Card muted className="mt-6 flex flex-wrap items-center gap-5">
                    <IconChip icon={CloudOff} tone="accent" size="lg"/>
                    <div className="min-w-0 flex-[1_1_320px]">
                        <h3 className="mb-2 text-title-sm">{t(I18nKeys.landing.offlineTitle)}</h3>
                        <p className="text-text-secondary">{t(I18nKeys.landing.offlineBody)}</p>
                    </div>
                </Card>
                <div className="mt-10 flex justify-center">
                    <RouterLink to="/how-it-works" className={buttonClassName({variant: 'secondary', size: 'lg'})}>
                        {t(I18nKeys.landing.howTitle)} <ArrowRight size={18}/>
                    </RouterLink>
                </div>
            </Container>
        </section>
    );
};
